/* tslint:disable:no-console */

import { register } from "register-service-worker";

const shouldRegisterServiceWorker =
  process.env.NODE_ENV === "production" && process.env.VUE_APP_ENV === "production";

export async function clearServiceWorkerState(): Promise<void> {
  const tasks: Promise<unknown>[] = [];

  if ("serviceWorker" in navigator) {
    tasks.push(
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) =>
          Promise.all(registrations.map((registration) => registration.unregister())),
        ),
    );
  }

  if ("caches" in window) {
    tasks.push(
      caches
        .keys()
        .then((cacheNames) =>
          Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName))),
        ),
    );
  }

  await Promise.allSettled(tasks);
}

if (shouldRegisterServiceWorker) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB",
      );
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updated() {
      console.log("New content is available; please refresh.");
    },
    offline() {
      console.log("No internet connection found. App is running in offline mode.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
} else {
  void clearServiceWorkerState();
}
